
import { useState } from "react";
import {
    Box,
    TextField,
    Button,
    Grid,
    Typography,
    MenuItem,
    Modal,
    CircularProgress,
   
} from "@mui/material";
import { useIngresoINMOB } from "../../Services/Inmobiliaria/Ingresos";
import { useIngresoTodosINMOB } from "../../Hook/Inmobiliaria/Ingresos";
import { Input, InputDescripcion, buttonGuardar, Texto, modalStyle } from "../../Layouts/CustomStyles";
import { formatCLP } from "../FuncionesGenerales/FormatoCLP";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";



export const CrearIngresoINMOB = ({ cerrarModal, refetchIngresos}) => {
       const {crearingreso}=useIngresoINMOB();

    const{refetchIngresoINMOB: fetchIngresoINMOB, IngresosCategoriaInmob, contactos}=useIngresoTodosINMOB();

    const [form, setForm] = useState({
        fecha_emision: "",
        fecha_pago: "",
        categoria_id: "",
        monto_bruto: "",
        iva: "",
        monto_neto: "",
        descripcion: "",
        forma_pago: "",
        informacion_adicional: "",
        estado: " ",
    });
    
    const [cuotas, setCuotas] = useState([]);
    const [cantidadCuotas, setCantidadCuotas] = useState("");
    const [interesCredito, setInteresCredito] = useState("");
    const [usarContacto, setUsarContacto] = useState(null);
    const [contactoSeleccionado, setContactoSeleccionado] = useState("");
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [contacto, setContacto] = useState({
        nombre: "",
        rut: "",
        empresa: "",
        telefono: "",
        email: "",
    });

    const [medioPago, setMedioPago] = useState({
        medio: "",
        banco: "",
        banco_otro: "",
        numero_documento: "",
       monto_pagado: ""
    });

    const resetForm = () => {
    setForm({
        fecha_emision: "",
        fecha_pago: "",
        categoria_id: "",
        monto_bruto: "",
        iva: "",
        monto_neto: "",
        descripcion: "",
        forma_pago: "",
        informacion_adicional: "",
    });

    setCuotas([]);
    setCantidadCuotas("");
    setInteresCredito("");

    setMedioPago({
        medio: "",
        banco: "",
        banco_otro: "",
        numero_documento: "",
        monto_pagado: ""
    });

    setContacto({
        nombre: "",
        rut: "",
        empresa: "",
        telefono: "",
        email: "",
    });

    setUsarContacto(null);
    setContactoSeleccionado("");
    setArchivo(null);
};
    const mediosPago = [
    "Transferencia",
    "Débito",
    "Crédito",
    "Cheque",
    "Efectivo"
];

const bancosChile = [
    "Banco de Chile",
    "Banco Estado",
    "Banco Santander",
    "BCI",
    "Scotiabank",
    "Itaú",
    "Banco Security",
    "Otro"
];
    const [archivo, setArchivo] = useState(null);

   // 🔹 Calcula el neto e IVA cuando el monto bruto ya incluye IVA
const calcularMontos = (formulario) => {
    const bruto = Number(formulario.monto_bruto);
    const iva = Number(formulario.iva);

    if (!bruto) {
        return {
            ...formulario,
            monto_neto: "",
            monto_iva: "",
        };
    }

    if (!iva) {
        return {
            ...formulario,
            monto_neto: bruto,
            monto_iva: 0,
        };
    }

    const neto = bruto / (1 + iva / 100);
    const montoIva = bruto - neto;

    return {
        ...formulario,
        monto_neto: Math.round(neto),
        monto_iva: Math.round(montoIva),
    };
};

// 🔹 HANDLE GENERAL
const handleChange = (e) => {
    const { name, value } = e.target;

    let newForm = { ...form };

    switch (name) {
        case "monto_bruto":
        case "monto_neto":
            newForm[name] = value
                .replace(/\./g, "")
                .replace(/[^0-9]/g, "");
            break;

        case "iva":
            newForm.iva = value
                .replace(/[^0-9.,]/g, "")
                .replace(",", ".");
            break;

        default:
            newForm[name] = value;
            break;
    }

    // Recalcular automáticamente cuando cambia el monto o el IVA
    if (name === "monto_bruto" || name === "iva") {
        newForm = calcularMontos(newForm);
    }

    setForm(newForm);
};

    const handleContacto = (e) => {
        setContacto({ ...contacto, [e.target.name]: e.target.value });
    };

   const handleMedioPago = (e) => {
    const { name, value } = e.target;

    setMedioPago(prev => ({
        ...prev,
        [name]: value,
        monto_pagado: form.monto_bruto
    }));

    // 👉 si NO es crédito, limpiar
    if (name === "medio" && value !== "Crédito") {
        setCuotas([]);
        setCantidadCuotas("");
        setInteresCredito("");
    }
};

   const generarCuotas = () => {
    if (!cantidadCuotas || !form.monto_neto || !form.fecha_emision || !form.fecha_pago) {
         setAlertMessage("Debes completar fechas de emisión, pago, monto y cuotas");
        setErrorAlertOpen(true);
        return;
    }

    const total = Number(form.monto_neto);
    const cantidad = Number(cantidadCuotas);
    const interes = Number(form.iva || 0);

    const montoConInteres = total + (total * (interes / 100));
    const montoCuota = montoConInteres / cantidad;

    const fechaEmisionBase = new Date(form.fecha_emision);
    const fechaPagoBase = new Date(form.fecha_pago);

    const nuevas = [];

    for (let i = 0; i < cantidad; i++) {

        const fechaEmision = new Date(fechaEmisionBase);
        fechaEmision.setMonth(fechaEmision.getMonth() + i);

        const fechaPago = new Date(fechaPagoBase);
        fechaPago.setMonth(fechaPago.getMonth() + i);

        nuevas.push({
            numero_cuota: i + 1,
            interes,
            monto_cuota: Math.round(montoCuota),
            fecha_emision: fechaEmision.toISOString().split("T")[0],
            fecha_pago: fechaPago.toISOString().split("T")[0]
        });
    }

    setCuotas(nuevas);
};



const handleCuotaChange = (index, field, value) => {
    const nuevas = [...cuotas];
    nuevas[index][field] = value;
    setCuotas(nuevas);
};
    // 🔹 SUBIR ARCHIVO
    const handleFile = (e) => {
        setArchivo(e.target.files[0]);
    };

const handleSubmit = async () => {
    try {
        setEnviandoAlert(true);
        setErrorAlertOpen(false);
        setSuccessAlertOpen(false);

        const formData = new FormData();

        // 🔹 datos principales
        Object.keys(form).forEach(key => {
            formData.append(key, form[key]);
        });

        // 🔹 contacto
        if (usarContacto === "existente") {
            formData.append("contacto_id", contactoSeleccionado);
        }

        if (usarContacto === "nuevo") {
            formData.append("nuevo_contacto", JSON.stringify(contacto));
        }

        // 🔥 medio pago limpio
        const medioPagoFinal = {
            medio: medioPago.medio,
            banco: medioPago.banco === "Otro" 
                ? medioPago.banco_otro 
                : medioPago.banco,
            numero_documento: medioPago.numero_documento,
            monto_pagado: Number(form.monto_neto) || 0
        };

        formData.append("medio_pago", JSON.stringify(medioPagoFinal));

        // 🔹 archivo
        if (archivo) {
            formData.append("archivo", archivo);
        }

        // 🔹 cuotas
        if (medioPago.medio === "Crédito") {
            formData.append("cuotas", JSON.stringify(cuotas));
        }

        await crearingreso(formData);

        setAlertMessage("Ingreso creado correctamente");
        setSuccessAlertOpen(true);
         resetForm();
        if (refetchIngresos) {
    refetchIngresos();
}
        setTimeout(() => {
    cerrarModal();
}, 1000);

    } catch (error) {
        console.error(error);
        setAlertMessage("Error al crear ingreso");
        setErrorAlertOpen(true);

    } finally {
        setEnviandoAlert(false);
    }
};
    return (
        <Box>



            <Grid container spacing={2}>
                <Grid size={12}>
                    <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px' }}>
                        < Typography sx={{ ...Texto, mb: 2 }}>Detalle Ingreso </ Typography>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    label="Fecha Emisión"
                                    type="date"
                                    name="fecha_emision"
                                    fullWidth
                                    value={form.fecha_emision}
                                    onChange={handleChange}
                                    sx={Input}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    label="Fecha Pago"
                                    type="date"
                                    name="fecha_pago"
                                    fullWidth
                                    value={form.fecha_pago}
                                    onChange={handleChange}
                                    sx={Input}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
    select
    label="Categoría"
    name="categoria_id"
    fullWidth
    value={form.categoria_id}
    onChange={handleChange}
    sx={Input}
>
    {IngresosCategoriaInmob?.length > 0 ? (
        IngresosCategoriaInmob.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
                {cat.nombre}
            </MenuItem>
        ))
    ) : (
        <MenuItem disabled value="">
            No hay categorías
        </MenuItem>
    )}
</TextField>
                            </Grid>
                            <Grid size={12}>
                                  <TextField
                                                  select
                                                  fullWidth
                                                  label="Estado ingreso"
                                                  name="estado"
                                                  sx={Input}
                                                  value={form.estado}
                                                  onChange={handleChange}
                                                  margin="normal"
                                                >
                                                  <MenuItem value="REGISTRADO">registrado</MenuItem>
                                                  <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                                                  <MenuItem value="PROCESO">Proceso</MenuItem>
                                                  <MenuItem value="NO PAGO">No pagado</MenuItem>
                                                  <MenuItem value="PAGADO">Pagado</MenuItem>
                                                  <MenuItem value="ANULADO">Anulado</MenuItem>
                                
                                                </TextField>
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    label="Descripción"
                                    name="descripcion"
                                    multiline
                                    rows={3}
                                    fullWidth
                                    value={form.descripcion}
                                    onChange={handleChange}
                                    sx={InputDescripcion}
                                />
                            </Grid>
                            <Grid size={12}>
                                <Button variant="outlined" component="label">
                                    Subir PDF / Imagen
                                    <input type="file" hidden onChange={handleFile} />
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Grid size={12}>
                    <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px' }}>
                        < Typography sx={{ ...Texto, mb: 2 }}>Detalle del monto </ Typography>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <TextField
                                    label="Monto Bruto"
                                    name="monto_bruto"
                                    fullWidth
                                    value={form.monto_bruto ? formatCLP(form.monto_bruto) : ""}
                                    onChange={handleChange}
                                    sx={Input}
                                />
                            </Grid>

                            <Grid size={12}>
                                <TextField
                                    label="IVA (%)"
                                    name="iva"
                                    fullWidth
                                    value={form.iva}
                                    onChange={handleChange}
                                    sx={Input}
                                />
                            </Grid>

                            <Grid size={12}>
                                <TextField
                                    label="Monto Neto"
    name="monto_neto"
    fullWidth
    value={form.monto_neto}
    onChange={handleChange}
    sx={Input}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid size={12}>
                    <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px' }}>

                        <Typography sx={{ ...Texto, mb: 2 }}>
                            Detalle contacto
                        </Typography>

                        {/* 🔹 BOTONES INICIALES */}
                        {usarContacto === null && (
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <Button
                                    variant="contained"
                                    onClick={() => setUsarContacto("existente")}
                                >
                                    Usar contacto existente
                                </Button>

                                <Button
                                    variant="outlined"
                                    onClick={() => setUsarContacto("nuevo")}
                                >
                                    Agregar nuevo contacto
                                </Button>
                            </Box>
                        )}

                        {/* 🔹 SELECT CONTACTO */}
                        {usarContacto === "existente" && (
                            <Box>
                                <TextField
                                    select
                                    fullWidth
                                    label="Seleccionar contacto"
                                    value={contactoSeleccionado}
                                    onChange={(e) => setContactoSeleccionado(e.target.value)}
                                    sx={{ ...Input, mb: 2 }}
                                >
                                    {/* 👉 esto debe venir de tu API */}
                                    {contactos?.map((c) => (
                                        <MenuItem key={c.id} value={c.id}>
                                            {c.nombre} - {c.empresa}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                <Button sx={buttonGuardar} onClick={() => setUsarContacto(null)}>
                                    ← Volver
                                </Button>
                            </Box>
                        )}

                        {/* 🔹 FORMULARIO NUEVO CONTACTO */}
                        {usarContacto === "nuevo" && (
                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField label="Nombre" name="nombre" fullWidth onChange={handleContacto} sx={Input} />
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField label="RUT" name="rut" fullWidth onChange={handleContacto} sx={Input} />
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField label="Empresa" name="empresa" fullWidth onChange={handleContacto} sx={Input} />
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <TextField label="Teléfono" name="telefono" fullWidth onChange={handleContacto} sx={Input} />
                                </Grid>

                                <Grid size={12}>
                                    <TextField label="Email" name="email" fullWidth onChange={handleContacto} sx={Input} />
                                </Grid>

                                <Grid size={12}>
                                    <Button sx={buttonGuardar} onClick={() => setUsarContacto(null)}>
                                        ← Volver
                                    </Button>
                                </Grid>

                            </Grid>
                        )}

                    </Box>
                </Grid>

                <Grid size={12}>
                    <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px' }}>
                        < Typography sx={{ ...Texto, mb: 2 }}>Detalle de Pago </ Typography>
                        <Grid container spacing={2}>

    <Grid size={12}>
        <TextField
            select
            label="Medio"
            name="medio"
            fullWidth
            value={medioPago.medio}
            onChange={handleMedioPago}
            sx={Input}
        >
            {mediosPago.map((m) => (
                <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
        </TextField>
    </Grid>

   <Grid size={12}>
    <TextField
        select
        label="Banco"
        name="banco"
        fullWidth
        value={medioPago.banco}
        onChange={handleMedioPago}
        sx={Input}
    >
        {bancosChile.map((b) => (
            <MenuItem key={b} value={b}>
                {b}
            </MenuItem>
        ))}
    </TextField>
</Grid>

{medioPago.banco === "Otro" && (
    <Grid size={12}>
        <TextField
            label="Especifique banco"
            name="banco_otro"
            fullWidth
            value={medioPago.banco_otro}
            onChange={handleMedioPago}
            sx={Input}
        />
    </Grid>
)}
    <Grid size={12}>
        <TextField
            label="N° Documento"
            name="numero_documento"
            fullWidth
            value={medioPago.numero_documento}
            onChange={handleMedioPago}
            sx={Input}
        />
    </Grid>

</Grid>
                    </Box>
                </Grid>
                                    
                                  {medioPago.medio === "Crédito" && (
    <Grid size={12}>
        <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px' }}>

            <Typography sx={{ ...Texto, mb: 2 }}>
                Detalle de Cuotas
            </Typography>

            {/* 👉 INTERÉS + CUOTAS */}
            <Grid container spacing={2}>

                

                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField
                        label="Cantidad de cuotas"
                        fullWidth
                        value={cantidadCuotas}
                        onChange={(e) => setCantidadCuotas(e.target.value)}
                        sx={Input}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Button
                        variant="contained"
                        onClick={generarCuotas}
                        sx={{ height: "100%" }}
                    >
                        Generar
                    </Button>
                </Grid>

            </Grid>

            {/* 👉 LISTA DE CUOTAS */}
            {cuotas.map((c, i) => (
                <Grid container spacing={2} key={i} mt={4}>

                    <Grid size={{ xs: 12, md: 2 }}>
                        <TextField
                            label={`Cuota #${c.numero_cuota}`}
                            value={c.numero_cuota}
                            disabled
                            fullWidth
                            sx={Input}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
    <TextField
        label="Monto cuota"
        value={c.monto_cuota ? formatCLP(c.monto_cuota) : ""}
        onChange={(e) =>
            handleCuotaChange(
                i,
                "monto_cuota",
                e.target.value.replace(/\./g, "").replace(/[^0-9]/g, "")
            )
        }
        fullWidth
        sx={Input}
    />
</Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            type="date"
                            label="Fecha emisión"
                            InputLabelProps={{ shrink: true }}
                            value={c.fecha_emision}
                            onChange={(e) =>
                                handleCuotaChange(i, "fecha_emision", e.target.value)
                            }
                            fullWidth
                            sx={Input}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            type="date"
                            label="Fecha pago"
                            InputLabelProps={{ shrink: true }}
                            value={c.fecha_pago}
                            onChange={(e) =>
                                handleCuotaChange(i, "fecha_pago", e.target.value)
                            }
                            fullWidth
                            sx={Input}
                        />
                    </Grid>

                </Grid>
            ))}

        </Box>
    </Grid>
)}

                {/* BOTON */}
                <Grid size={12}>
                    <Button sx={buttonGuardar} onClick={handleSubmit}>
                        Guardar Ingreso
                    </Button>
                </Grid>

            </Grid>

               <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: "center" }}>
                                    <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                                    <p className="alert-text">{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: "center" }}>
                                    <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                                    <p className="alert-text">{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        <Modal open={enviandoAlert}>
                            <Box sx={modalStyle}>
                                <section style={{ textAlign: "center", padding: "1rem" }}>
                                    <CircularProgress style={{ color: "#2a8d74" }} />
                                    <p className="alert-text">Procesando solicitud...</p>
                                </section>
                            </Box>
                        </Modal>
        </Box>
    );
};